var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "custom-fields-preview-component" },
    [
      _vm.formPreviewSchema && _vm.formPreviewSchema.length
        ? _c("FormGeneratorComponent", {
            attrs: { schema: _vm.formPreviewSchema, context: _vm.context },
          })
        : _c("CustomFieldsEmptyMessageComponent"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }